import {
  IFRAME_DATA_TEST_ID,
  IFRAME_ID,
} from "@circle-react-shared/BuilderUI/Frames/constants";
import type { ResponsiveFrameProps } from "@circle-react-shared/ResponsiveFrame";
import { ResponsiveFrame } from "@circle-react-shared/ResponsiveFrame";

const headStyle = (
  /** Styles for droppable zone */
  <style>
    {`
    body {
      margin: 0;
      max-width: 100%;
      overflow: hidden;
      word-wrap: break-word;
      word-break: break-word;
    }
    p {
      margin: 0;
    }
    [data-droppable-area] {
    height: 1rem;
    z-index: 10;
    margin-bottom: -1rem;
    width: 100%;
  }
  .wb-bg-blue-400 {
    background-color: rgb(96 165 250 / 1);
  }
  .wb-bg-red-400 {
    background-color: rgb(239 68 68 / 1);
  }
  [data-drop-area] {
    height: 1rem;
    width: 100%;
    border-radius: 0.25rem;
    border-width: 2px;
    border-style: dashed;
    padding: 0.5rem;
    border-color: #00000044;
  }
  .wb-hidden {
    display: none;
  }
  [data-droppable-preview-is-over="true"] {
    box-shadow: 0 3px 0 0 #3b82f6;
  }
  [data-preview-mode-is-inline-editing="true"] {
    outline: none;
  }
  [data-preview-component-wrapper] {
    box-sizing: border-box;
    user-select: none;
    position: relative;
    height: 100%;
  }
  .ProseMirror {
    max-width: 100% !important;
    overflow: hidden !important;
    box-sizing: border-box !important;
    word-wrap: break-word !important;
    word-break: break-word !important;
  }
  [data-testid="builder-tiptap-editor"] {
    max-width: 100% !important;
    overflow: hidden !important;
  }
  `}
  </style>
);
export function EmailFrame({ id = IFRAME_ID, ...rest }: ResponsiveFrameProps) {
  return (
    <ResponsiveFrame
      id={id}
      data-testid={IFRAME_DATA_TEST_ID}
      head={headStyle}
      shouldAdaptHeightToContentSize
      style={{ position: "relative" }}
      {...rest}
    />
  );
}
